/**
 * Default date window the main dashboard opens on.
 *
 * The date picker's selectable bounds come from GET /eventDateRange (the
 * `date_range` table, rebuilt on every import); this only sets the initial
 * selection and the first query. Update after each season cutover.
 */
export const DEFAULT_EVENT_DATES = ['2025-10-01', '2026-07-06'];

// "from,to" as the backend `event_date` param expects it
export const DEFAULT_EVENT_DATE_PARAM = DEFAULT_EVENT_DATES.join(',');
